import type {AppLanguageCode} from '../../shared/i18n/app-language';
import type {SmNavMenuItemModel} from '../../shared/components/sm-nav-menu-item/sm-nav-menu-item.component';

export function buildGuidesNavigation(
  language: AppLanguageCode, baseUrl: string, native: boolean,
  labels: {guides: string; external: string},
): SmNavMenuItemModel {
  return {
    id: 'guides', text: labels.guides, iconName: 'book-outline', tone: 'blue',
    externalHref: new URL(`/${language}/guides`, new URL(baseUrl).origin).toString(),
    externalNative: native, externalLabel: labels.external,
  };
}
